import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { FaturaEnComponent } from './fatura-en.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [FaturaEnComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NgxCaptchaModule,
    RouterModule,
  ],
})
export class FaturaEnModule {}
